import React, { useEffect, useState } from 'react';
import './CostTable.css';

const courses = [
  { name: "AI開発者", cost: "795,000円" },
  { name: "データサイエンティスト", cost: "795,000円" },
  { name: "ゲームアプリ開発者", cost: "795,000円" },
  { name: "CG・アニメーションクリエイター", cost: "795,000円" },
  { name: "メタバースクリエイター", cost: "755,000円" },
  { name: "Webアプリ開発者", cost: "695,000円" },
  { name: "Webサイトクリエイター", cost: "595,000円" },
  { name: "クリエイティブデザイン", cost: "595,000円" },
  { name: "デジタルツインマスター", cost: "1,055,000円" }
];

const CostTable = () => {
  const [selectedTab, setSelectedTab] = useState('student');
  const [showArrow, setShowArrow] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const wrapper = document.querySelector('.cost-table-wrapper');
      if (!wrapper) return;
      const scrollLeft = wrapper.scrollLeft;
      const maxScrollLeft = wrapper.scrollWidth - wrapper.clientWidth;
      if (wrapper.scrollWidth <= wrapper.clientWidth || scrollLeft >= maxScrollLeft) {
        setShowArrow(false);
      } else {
        setShowArrow(true);
      }
    };

    const wrapper = document.querySelector('.cost-table-wrapper');
    if (wrapper) {
      wrapper.addEventListener('scroll', handleScroll);
      handleScroll();
    }
    return () => wrapper && wrapper.removeEventListener('scroll', handleScroll);
  }, [selectedTab]);

  // 学生向けデータ
  const studentData = courses.map(course => ({
    name: course.name,
    period: '1年または2年',
    months: '4月, 7月, 10月, 1月',
    cost: '1,129,800円'
  }));

  // その他（社会人・支援利用者）向けデータ
  const otherData = courses.map(course => ({
    name: course.name,
    period: '4～12ヶ月',
    months: '毎月',
    cost: course.cost
  }));

  return (
    <div className="cost-section">
      <h2>受講プランと費用</h2>
      {/* タブ切り替え */}
      <div className="tabs">
        <button
          className={selectedTab === 'student' ? 'active' : ''}
          onClick={() => setSelectedTab('student')}
        >
          学生 (高校・大学相当)
        </button>
        <button
          className={selectedTab === 'other' ? 'active' : ''}
          onClick={() => setSelectedTab('other')}
        >
          社会人・支援利用者
        </button>
      </div>

      {/* 学生タブ内容 */}
      {selectedTab === 'student' && (
        <div className="tab-content">
          <div className="cost-table-wrapper">
            <table className="cost-table">
              <thead>
                <tr>
                  <th>コース名</th>
                  <th>期間</th>
                  <th>入学月</th>
                  <th>費用</th>
                </tr>
              </thead>
              <tbody>
                {studentData.map((item, idx) => (
                  <tr key={idx} className={idx % 2 === 0 ? 'even-row' : 'odd-row'}>
                    <td>{item.name}</td>
                    <td>{item.period}</td>
                    <td>{item.months}</td>
                    <td>{item.cost}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* 社会人・支援利用者タブ内容 */}
      {selectedTab === 'other' && (
        <div className="tab-content">
          <div className="cost-table-wrapper">
            <table className="cost-table">
              <thead>
                <tr>
                  <th>コース名</th>
                  <th>期間目安</th>
                  <th>入学時期</th>
                  <th>費用</th>
                </tr>
              </thead>
              <tbody>
                {otherData.map((item, idx) => (
                  <tr key={idx} className={idx % 2 === 0 ? 'even-row' : 'odd-row'}>
                    <td>{item.name}</td>
                    <td>{item.period}</td>
                    <td>{item.months}</td>
                    <td>{item.cost}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {showArrow && <i className="scroll-icon fa fa-arrow-right"></i>}

        <div className="cost-notice">
            <h3>学生プランキャンペーン</h3>
            <p>現在、10月入学対象者限定で、学生対象者様に向けたキャンペーンを行なっております。</p>

            <button className="cost-notice-button">
                <a href="/student" rel="noopener noreferrer">詳細はこちら</a>
            </button>
        </div>
    </div>
  );
};

export default CostTable;